export interface ISessionType {
  id?: number;
  name?: string;
  estimatedDuration?: number;
}

export const defaultValue: Readonly<ISessionType> = {};
